/**
 * Canonical `public.tiers.id` values for MyTCGBinder Vendor.
 *
 * Shell: any. Pure constants — no data fetching, no store dependency.
 *
 * Non-obvious contract: these two ids (`vendor_pro`, `vendor_trial`) are the
 * only rows `public.tiers` defines. They replaced the storefront-inherited
 * `storefront_v2` / `storefront_v2_trial` ids in
 * `supabase/migrations/20260720000000_account_members_and_invites.sql`
 * (vendor#18 / vendor#79). That migration is a DROP + INSERT with no
 * compatibility window, so a stale literal fails at runtime, not at build —
 * `tsc` and ESLint cannot catch a wrong tier-id string.
 *
 * Import {@link VENDOR_TIER_IDS} instead of writing the id as a string
 * literal (test fixtures included) so a future tier rename is a one-file
 * change instead of a grep across every call site and fixture.
 */
export const VENDOR_TIER_IDS = {
  PRO: 'vendor_pro',
  TRIAL: 'vendor_trial',
} as const;

export type VendorTierId = (typeof VENDOR_TIER_IDS)[keyof typeof VENDOR_TIER_IDS];
